<template>
  <div class="reports-container">
    <h3>📊 Reportes Generados</h3>

    <b-table
      striped
      hover
      :items="reports"
      :fields="fields"
      responsive="sm"
      small
    >
      <template #cell(actions)="row">
        <b-button
          size="sm"
          variant="success"
          :href="row.item.url"
        >
          Descargar
        </b-button>
      </template>
    </b-table>

    <div v-if="reports.length === 0" class="text-muted mt-3">
      No hay reportes generados aún.
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Reports",
  data() {
    return {
      reports: [],
      fields: [
        { key: "fileName", label: "Nombre del archivo" },
        { key: "fecha", label: "Fecha de generación" },
        { key: "actions", label: "Acciones" },
      ],
    };
  },
  async created() {
    try {
      const { data } = await axios.get(
        `${process.env.VUE_APP_URL_API}/v1/sales/excel/links`
      );
      this.reports = data;
    } catch (error) {
      console.error("Error obteniendo reportes:", error);
    }
  },
};
</script>

<style scoped>
.reports-container {
  padding: 1rem;
}
</style>